export default "__VITE_ASSET__B4Q0KTqO__"